const VERSION = "10.0.8";
export {
  VERSION
};
